<template>
    <div>
      <!-- NAVBAR -->
      <my-navbar :controller="controller" />

      <!-- HEADER -->
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-6 col-md-10 mb-5">
              <h1 class="display-3 text-white">Formulario DFP</h1>
              <template v-if="dfpForm.id > 0">
                <p class="text-white">Seleccionado: <strong>{{ dfpForm.caption }}</strong></p>
                <p><button class="btn btn-secondary btn-sm"  @click="restart()" :disabled="loading"> <i class="fa fa-refresh text-primary"></i> Cambiar Formulario</button></p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!-- CONTENT -->
      <div class="container-fluid mt--7">
        <div class="row" v-show="dfpForm.id == 0">
          <div class="col-md-4"></div>
          <div class="col-md-4">
                <form class="card shadow" @submit.prevent="addEncabezado()">
                  <div class="card-header">
                    Selecciona o crea un formulario
                  </div>
                  <div class="card-body bg-secondary p-relative">

                    <div class="form-group" v-show="!adding">
                        <v-select
                          style="width:100%;"
                          placeholder="Buscar formulario"
                          :options="forms"
                          label="caption"
                          v-model="encabezado"
                        >
                          <span slot="no-options"  v-if="actions.post">
                            <button class="btn btn-link btn-sm" type="button" @click="addMode(true)">Agregar nuevo</button>
                          </span>
                        </v-select>
                    </div>
                    <div class="form-group" v-if="!adding">
                        <button class="btn btn-link btn-sm" type="button"  @click="addMode(true)" v-if="actions.post">
                          <i class="fa fa-plus-circle text-success"></i> Crear nuevo
                        </button>
                    </div>

                      <div class="fields" v-if="encabezado && adding">
                        <h4>Agregar nuevo formulario</h4>
                        <div class="form-group">
                          <label class="text-small" for="">Título</label>
                          <input type="text" placeholder="Título del Formulario" class="form-control form-control-alternative" v-model="encabezado.caption" :disabled="loading" maxlength="20">
                        </div>
                        <div class="form-group">
                          <label class="text-small" for="">Descripción</label>
                          <input type="text" placeholder="Breve descripción" class="form-control form-control-alternative"  v-model="encabezado.description" :disabled="loading" maxlength="50">
                        </div>
                      </div>

                    </div>
                    <div class="card-footer text-right">
                      <button class="btn btn-secondary" type="button" v-if="adding" @click="addMode(false)">Cancelar</button>
                      <button type="submit" class="btn btn-default" :disabled="!validEncabezado || loading" v-text="loading ? 'Cargando...':'Continuar'">
                        Continuar
                      </button>
                    </div>
                </form>
          </div>
        </div>
        <div class="row" v-show="dfpForm.id > 0">
          <div class="col">
            <!-- COMPONENTE PRINCIPAL -->
            <div class="row">
              <div class="col-md-8">
                <div class="card shadow">

                  <div class="card-header" :class="field.id > 0 ? 'bg-info text-white': 'bg-success text-white'" v-text="field.id > 0 ? 'Modo edición' : 'Agregando nuevo campo'"></div>

                  <div class="card-body bg-secondary p-relative">
                    <div class="row">
                      <div class="col-sm-12 fadeInUp" v-show="field.id > 0">
                          <p class="text-small"><i class="fa fa-edit text-muted"></i> Estás editando el campo <strong class="text-primary">{{ field.caption }}</strong></p>
                      </div>
                      <div class="col-md-4">
                          <div class="form-group">
                            <label class="text-small" for="">Tipo (<span class="text-danger">*</span>)</label>
                            <select  class="form-control form-control-alternative" v-model="field.te_id" @change="filterInputs()" :disabled="field.id > 0">
                              <option value="0">---</option>
                              <template v-for="type in fieldsTypes">
                                  <option :key="type.id" :value="type.id">{{ type.caption }}</option>
                              </template>
                            </select>
                          </div>
                      </div>
                      <div class="col-md-4">
                          <div class="form-group">
                            <label class="text-small" for="">Categoría (<span class="text-danger">*</span>)</label>
                            <select  class="form-control form-control-alternative" v-model="field.td_id" @change="setWS()">
                              <option value="0">---</option>
                              <template>
                                <option v-for="i in inputs" :key="i.id" :value="i.id">{{ i.caption }}</option>
                              </template>
                            </select>
                          </div>
                      </div>
                    </div>

                    <div class="row fadeInUp" v-if="(field.te_id == 2 && (field.td_id != 14 && field.td_id != 15 && field.td_id != 18 && field.td_id != 20))">
                      <div class="col-md-12  mt-20"><h4>Agregar opciones a Listado (<span class="text-danger">*</span>)</h4></div>
                      <div class="col-md-5">
                        <div class="form-group">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Agrega una opción" v-model="newOption.caption" @keyup.enter="addOption()" :disabled="loading">
                              <div class="input-group-append">
                                <button class="btn btn-success" type="button" @click.prevent="addOption()" :disabled="loading || invalidOption"><i class="fa" :class="loading ? 'fa-plus-spinner fa-spin':'fa-plus-circle'"></i></button>
                              </div>
                            </div>
                        </div>
                        <p v-if="field.values.length == 0" class="text-muted text-small"> <i class="fa fa-info-circle text-danger"></i> No tienes opciones en tu <strong><u>campo lista</u></strong></p>
                        <table v-else class="table">
                          <thead class="text-center">
                            <tr>
                              <th style="min-width:150px">#Id Externo</th>
                              <th>Descripción</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(option, indexOption) in field.values" :key="'_key ' + indexOption">
                              <!--td>{{ option.id }}</td-->
                              <td><input type="text" v-model="option.id_ex" class="form-control" placeholder="#0000" /></td>
                              <td style="vertical-align:middle">
                                <span class="text-muted">{{ option.id }}#</span> {{ option.caption }}
                                <button class="btn btn-icon btn-2 btn-link text-danger btn-sm" title="Eliminar" type="button" @click="deleteOption(option, indexOption)">
                                  <span class="btn-inner--icon"><i class="fa fa-trash"></i></span>
                                </button>
                              </td>                              
                            </tr>
                          </tbody>
                        </table>
                        <!--ol v-else class="mb-20 text-small">
                          <li v-for="(option, indexOption) in field.values" :key="'_key ' + indexOption"> 
                            
                            {{ option.caption }} 
                            <input type="text" v-model="option.id_ex" />
                            <button class="btn btn-icon btn-2 btn-link text-danger btn-sm" title="Eliminar" type="button" @click="deleteOption(option, indexOption)">
                              <span class="btn-inner--icon"><i class="fa fa-trash"></i></span>
                            </button>
                          </li>
                        </ol-->
                      </div>
                    </div>

                    <!-- Detalles de los campos -->
                   
                    <div class="row  mt-10 fadeInUp" v-show="field.te_id > 0">
                      <div class="col-md-12"><h4>Detalles del campo</h4></div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label class="text-small" for="">Etiqueta (<span class="text-danger">*</span>)</label>
                          <input type="text" placeholder="Titulo del campo" class="form-control form-control-alternative" v-model="field.caption" :disabled="loading" maxlength="200">
                        </div>
                      </div>
                      <div class="col-md-4 fadeInUp" v-show="field.te_id == 1">
                        <div class="form-group">
                          <label class="text-small" for="">Placeholder</label>
                          <input type="text" placeholder="Descripción" class="form-control form-control-alternative" v-model="field.placeholder" :disabled="loading" maxlength="200">
                        </div>
                      </div>
                      <div class="col-md-4 fadeInUp" v-show="field.te_id == 1">
                        <div class="form-group">
                          <label class="text-small" for="">Validar campo como</label>
                            <input type="text" placeholder="Agrega una expresión regular (opcional)" class="form-control form-control-alternative" :disabled="loading" v-model="field.regex">
                        </div>
                      </div>
                      <div class="col-md-4 fadeInUp" v-show="field.te_id == 1">
                        <div class="form-group">
                          <label class="text-small" for="">Valor predeterminado</label>
                          <input type="text" class="form-control form-control-alternative" :disabled="loading" v-model="field.default_value" maxlength="200">
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label class="text-small" for="">Orden</label>
                          <input type="number" class="form-control form-control-alternative" :disabled="loading" min="0" max="10" v-model="field.orden" maxlength="2">
                          <span v-if="invalidOrder" class="text-help text-small text-danger">Valor inválido</span>
                        </div>
                      </div>
                      <div class="col-md-4 fadeInUp" v-show="field.te_id == 1">
                        <div class="form-group">
                          <label class="text-small" for="">Máximo de caracteres</label>
                          <input type="number" class="form-control form-control-alternative" :disabled="loading" min="0" max="250" v-model="field.maxlength" maxlength="3">
                          <span v-if="invalidMaxlength" class="text-help text-small text-danger">Valor inválido</span>
                        </div>
                      </div>
                      <div class="col-md-4 fadeInUp" v-show="field.te_id == 2 && dfpForm.fields.length > 0">
                        <div class="form-group">
                          <label class="text-small" for="">Dependiente:</label>
                            <select  class="form-control form-control-alternative" v-model="field.fd_id">
                              <option value="0">---</option>
                              <template v-for="child in filterChild()">
                                <option :key="'childkey_'+child.id" :value="child.id"> {{child.caption}} </option>
                              </template>
                            </select>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" id="requiredField" type="checkbox" v-model="field.required">
                            <label class="custom-control-label" for="requiredField">¿Requerido?</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 text-right">
                        <div class="form-group">
                          <button class="btn btn-link" v-if="field.id > 0" @click="resetField"><i class="fa fa-times text-muted"></i> Cerrar edición</button>
                          <button v-if="actions.post" class="btn" :class="field.id > 0 ? 'btn-info': 'btn-success'" @click="addField()" :disabled="invalidField || invalidOrder || invalidMaxlength || invalidOptionsLength ||  loading" v-text="loading ? 'Guardando...':'Guardar campo'">Guardar campo</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card">
                  <div class="card-header bg-primary text-white">
                    Campos del formulario
                  </div>
                  <div class="card-body1 bg-secondary">
                    <div class="list-groupl">
                      <div  class="list-group-item" v-if="dfpForm.fields.length == 0">
                        No hay campos agregados
                      </div>
                      <div v-else  class="list-group-item list-field-item" v-for="( i, fieldIndex ) in dfpForm.fields" :key="'field_' + fieldIndex" :class="{'active': i.id == field.id}">
                        {{ i.caption }}
                        <div class="btn-group btn-group-sm float-right">
                          <button v-if="actions.put" class="btn btn-secondary" @click="editMode(i)" ><i class="fa fa-edit text-info"></i></button>
                          <button v-if="actions.delete" class="btn btn-danger" @click="deleteField(i, fieldIndex)"><i class="fa fa-trash"></i></button>
                        </div>
                      </div>
                    </div>   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>
<script>
import _ from 'underscore';
import Auth from '@/helpers/middleware'
import sysMsgs from "@/helpers/system.message";
import dfpServices from '@/services/dfp.services';
import { DFPForm, Field, Encabezado, FieldType, InputModel, ListOption } from '@/views/marketing/campaigns/models/form.model';

  export default {
    name: "CreateDFPForm",
    data() {
      return {
        actions: Auth.getActions(this.$route.name),
        controller: {
          title: "Marketing",
          mainRouter: "/marketing/crear/formulario"      
        },
        tmpCat: '',
        adding: false,
        loading: false,
        inputs:[],
        forms: [],
        fieldsTypes: [],
        newOption: new ListOption(),
        encabezado: new Encabezado(),
        field: new Field(),
        dfpForm: new DFPForm()
      };
    },
    created(){
      this.getForms();
      this.getFieldsTypes();
      this.field = new Field();
    },
    computed: {
      validEncabezado(){
        return this.encabezado != null ? this.encabezado.caption.trim().length > 4 : false
      },
      invalidField(){
        return !this.field.te_id || !this.field.td_id || this.field.caption.trim().length < 3
      },
      invalidOption(){
        return this.newOption.caption.trim().length < 1
      },
      invalidOrder(){
        return this.field.orden > 20;
      },
      invalidMaxlength(){
        return this.field.maxlength > 250;
      },
      invalidOptionsLength(){
        return  (this.field.te_id == 2 && this.field.values.length == 0) && !_.contains([14,15,18,20], this.field.td_id)
      }
    },
    watch: {
      encabezado: {
        handler(data){
          if(!data){
            this.encabezado = new Encabezado();
          }
        }
      },
      'field.te_id': {
        handler(data){
          if(this.field.id == 0 && data){
            this.field.td_id = 0;
          }
        }
      }
    },
    methods: {
      setWS() {
        if(this.field.td_id > 0) {
          let x = _.find(this.inputs, find => find.id == this.field.td_id );
          this.field.ws = x.ws; this.field.ws_params = x.ws_params;
        }
      },
      addMode(val){
        this.adding = val;
        this.encabezado = new Encabezado();
      },
      filterInputs(){
        if(this.field.te_id > 0) {
          this.inputs = _.find(this.fieldsTypes, x => x.id == this.field.te_id).inputs
        } else {
          this.inputs = []
        }
      },
      filterChild(){
        const tmp = this.field.id > 0 ? _.filter(this.dfpForm.fields, filter => filter.id == this.field.id || filter.fd_id == this.field.id && this.field.te_id == 2) : [];
        return _.filter(this.dfpForm.fields, filter => !_.contains(_.map(tmp, map => map.id), filter.id)  && filter.te_id == 2)
      },
      getForms(){
        this.loading = true;
        dfpServices.forms.getAll().then(response => {
          this.forms = response.data.forms;
          this.loading = false;
        }).catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.loading = false;
        });
      },
      getFieldsTypes(){ 
        this.loading = true;
        dfpServices.forms.getFieldsTypes().then(response => {
          this.fieldsTypes = response.data.tipos;
          this.loading = false;
        }).catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.loading = false;
        });
      },
      addEncabezado() {
        if(this.encabezado.id > 0 && this.validEncabezado) {
          this.dfpForm = this.encabezado
          this.addMode(false)
        } else if (this.validEncabezado) {
          this.loading = true;
          dfpServices.forms.setEncabezado(this.encabezado).then(response => {
            this.dfpForm = response.data;
            this.forms.push(response.data);
            this.addMode(false)
            sysMsgs.getMessage("Agregado correctamente.", "success");
            this.loading = false;
          }).catch(error => {
            sysMsgs.getResponseMessage(error.response);
            this.loading = false;
          });
        }
      },
      addField(){
        this.field.fe_id = this.dfpForm.id;
        const id = this.field.id;
        this.loading = true;
        dfpServices.forms.setField(this.field).then(response => {
          if(id == 0) {
            this.dfpForm.fields.push(response.data);
            sysMsgs.getMessage("Campo agregado.", "success");
            this.field = new Field();
          } else {
            _.extend(_.findWhere(this.dfpForm.fields, { id: response.data.id }),  response.data)
            sysMsgs.getMessage("Campo actualizado.", "success");
          }
          this.loading = false;
        }).catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.loading = false;
        });
      },
      deleteField(field, index){
        sysMsgs.getConfirm("¿Está seguro?", "warning").then(result => {
            if (result.value) {
              this.loading = true;
              dfpServices.forms.removeField(field).then(response => {
                this.dfpForm.fields.splice(index, 1);
                sysMsgs.getMessage("Campo eliminado.", "warning");
                this.loading = false;
                
                if(this.field.id == field.id)
                  this.field = new Field()

              }).catch(error => {
                sysMsgs.getResponseMessage(error.response);
                this.loading = false;
              });
            }
        });
      },
      addOption(){
        this.field.values.push(this.newOption);
        this.newOption = new ListOption()
      },
      editMode(field) {
        this.field = field;
        this.filterInputs();
      },
      deleteOption(option, index) {
        if(this.field.id > 0) {
          sysMsgs.getConfirm("¿Está seguro?", "warning").then(result => {
              if (result.value) {
                this.loading = true;
                dfpServices.forms.RemoveList(option).then(response => {
                  this.field.values.splice(index, 1);
                  sysMsgs.getMessage("Opción eliminado.", "warning");
                  this.loading = false;
                }).catch(error => {
                  sysMsgs.getResponseMessage(error.response);
                  this.loading = false;
                });
              }
          });
        } else {
          this.field.values.splice(index, 1);
        }
        
      },
      resetField() {
        this.field = new Field();
      },
      restart() {
        sysMsgs.getConfirm("¿Está seguro?", "question").then(result => {
            if (result.value) {
              this.newOption = new ListOption()
              this.encabezado = new Encabezado();
              this.field = new Field();
              this.dfpForm = new DFPForm()
              this.dfpForm.id = 0;
            }
          });
      },
      sortFields(arr){
        return arr.sort(i => i.orden);
      }
    }
  };
</script>

<style scoped>
.list-group-item {
  padding: .61rem .61rem;
}
.list-group-item.active {
  background-color: #2196f3;
  border-color: #2196f3;
}
</style>
